import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Extrae parámetros de autenticación desde la URL de la ubicación actual.
 */
export const useAuthUrlParams = () => {
  const { pathname, search } = useLocation()

  const normalizedPathname = useMemo(() => (pathname === '/' ? pathname : pathname.replace(/\/$/, '')), [pathname])

  const searchParams = useMemo(() => new URLSearchParams(search), [search])

  const urlUuid = useMemo(() => searchParams.get('token') || searchParams.get('uuid') || null, [searchParams])

  const idcertificadoUrl = useMemo(() => {
    const rawId = searchParams.get('idcertificado') || searchParams.get('idCertificado') || null
    const idcert = rawId != null ? Number(rawId) : null
    return Number.isInteger(idcert) && idcert > 0 ? idcert : null
  }, [searchParams])

  return { pathname, normalizedPathname, urlUuid, idcertificadoUrl }
}
